export const helpItems = [
  {
    title:'Required Fields',
    content:'Fields marked with an asterisk (*) are mandatory and must be completed in the system.'
  },
  {
    title:'Numbers',
    content:`Use only comma (,) to represent thousands, for example 1000,00. The dot (.) is not accepted by the system in these cases.`
  }
] 